import { render, staticRenderFns } from "./InfoReportGroup.vue?vue&type=template&id=192563f6&scoped=true&"
import script from "./InfoReportGroup.vue?vue&type=script&lang=js&"
export * from "./InfoReportGroup.vue?vue&type=script&lang=js&"
import style0 from "./InfoReportGroup.vue?vue&type=style&index=0&id=192563f6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192563f6",
  null
  
)

export default component.exports